import HasLabel from "@/models/HasLabel";
import TrackedObject from "./TrackedObject";
import { PriceSchedule } from "./PriceSchedule";

export interface PharmacyBenefitManager extends TrackedObject {
    id: number;
    name: string;
    mailOrderDaySupply: number | null;
    vendorId: string;
    allowedStates: AllowedStates[];
    exemptedNdcs: string[];
    flags: Flags;
    bins: string[];
    defaultPriceScheduleId?: number | null;
    defaultPriceSchedule?: PriceSchedule | null;
    compoundProductServiceQualifier?: string | null;
    compoundProductServiceId?: string | null;
    sendCompoundType?: boolean | null;
}

export interface AllowedStates {
    storeId: number;
    states: string[];
}

export enum Flags {
    None,
    CovidPcn
}

export class PharmacyBenefitManager extends HasLabel {
    constructor(pbm?: PharmacyBenefitManager) {
        super();
        this.allowedStates = [];
        this.exemptedNdcs = [];
        this.bins = [];
        this.defaultPriceScheduleId = null;
        this.defaultPriceSchedule = new PriceSchedule();
        if (pbm) {
            Object.assign(this, pbm);
            if (pbm.defaultPriceSchedule) {
                this.defaultPriceSchedule = new PriceSchedule(pbm.defaultPriceSchedule);
            }
        }
    }

    toString(): string {
        let label = "";
        if (this.name) {
            label = "Id: " + this.id + " Name: " + this.name;
        }
        return label;
    }
}
